export const conferenceTypesEnum = {
    'group': 'group', //Групповой
    'private': 'private', //Индивидуальный
    'customizable': 'customizable', //Настраиваемый
}